<div class="banner-tpa">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-12 col-md-4 col-xl-3 text-center py-10x">
                <img class="imgSolTpa" src="./assets/images/footer/soluciones_tpa_blanco.png" />
            </div>
            <div class="col-12 col-md-8 col-xl-9 py-10x">
                <p>Por tiempo limitado, al contratar con Coche Seguro <b>te regalamos más cobertura</b><br class="d-none d-xl-block" />
                de Responsabilidad Civil así como más asistencias.&nbsp;<a href="https://storage.googleapis.com/coche-seguro-inter/CondicionesGenerales.pdf" target="_blank">Conoce más de este beneficio</a>
                </p>
            </div>
        </div>
    </div>
</div>
<div class="footer" [ngStyle]="{'background-color':styleCocheSeguro.bgFooter}">
    <div class="table-sio w-100 h-100">
        <div class="row-sio">
            <div class="cell-sio text-middle">
                <div class="container m-auto mt-40x">
                    <div class="row">
                        <div class="mt-4 col-lg-2 col-md-2 col-12">
                            <img class="logoInter" src="./assets/images/footer/INTERMX V-Wh.svg" />
                            <!--<img class="logoSha" src="./assets/images/footer/SHA 256.png" />-->
                          </div>
                        <div class="mt-4 col-lg-2 col-md-2 col-12">
                            <p style="font-style:normal;font-size:0.8rem;color:#bdbebf;margin-bottom:40px">Servicios</p>
                            <p class="white link mb-1rem" style="font-style:normal;font-size:15px" (click)="openWindow(1)">Seguros y Fianzas</p>
                            <p class="white link mb-1rem" style="font-style:normal;font-size:15px" (click)="openWindow(3)">Reaseguro</p>
                            <p class="white link mb-1rem" style="font-style:normal;font-size:15px" (click)="openWindow(4)">Microseguros</p>
                            <p class="white link mb-1rem" style="font-style:normal;font-size:15px" (click)="openWindow(5)">Líneas financieras</p>
                            <p class="white link mb-1rem" style="font-style:normal;font-size:15px" (click)="openWindow(6)">Soluciones TPA</p>
                        </div>
                        
                        <div class="mt-4 col-lg-2 col-md-2 col-12">
                            <p style="font-style:normal;font-size:0.8rem;color:#bdbebf;margin-bottom:40px">Nuestros productos</p>
                            <p class="white link mb-1rem"  style="font-style:normal;font-size:15px" (click)="openWindow(18)">Seguro de coche</p>
                            <p class="white link mb-1rem"  style="font-style:normal;font-size:15px" (click)="openWindow(8)">Médico Seguro</p>
                            <p class="white link mb-1rem"  style="font-style:normal;font-size:15px" (click)="openWindow(9)">Bien Seguro</p>
                            <p class="white link mb-1rem"  style="font-style:normal;font-size:15px" (click)="openWindow(19)">Mascota Segura</p>
                            <p class="white link mb-1rem"  style="font-style:normal;font-size:15px" (click)="openWindow(20)">Vida Segura</p>
                        </div>

                        <div class="mt-4 col-lg-2 col-md-2 col-12">
                            <p style="font-style:normal;font-size:0.8rem;color:#bdbebf;margin-bottom:40px">Contáctanos</p>
                            <p class="white link mb-2rem" style="font-style:normal;font-size:15px" (click)="openWindow(11)"><mat-icon class="fs-18 text-middle">call</mat-icon>&nbsp;&nbsp;55442 46837</p>
                            <p class="white link mb-2rem" style="font-style:normal;font-size:15px" (click)="openWindow(12)"><mat-icon class="fs-18 text-middle">email</mat-icon>&nbsp;&nbsp;hola@inter.mx</p>
                        </div>

                        <div class="mt-4 col-lg-2 col-md-2 col-12">
                            <p style="font-style:normal;font-size:0.8rem;color:#bdbebf;margin-bottom:40px">Clientes</p>
                            <p class="white link mb-1rem" style="font-style:normal;font-size:15px" (click)="openWindow(13)">Login</p>
                            <br />
                        </div>

                        <div class="mt-4 col-lg-2 col-md-2 col-12">
                          <p style="font-style:normal;font-size:0.8rem;color:#bdbebf;margin-bottom:40px">Obten nuestra app</p>

                          <a target="blank" href="https://play.google.com/store/apps/details?id=grut.inter.mx">
                            <img style="width:10pc;height:3pc;margin:0.5pc;margin-left:0px" src="./assets/images/footer/GoogleGris.png">
                          </a>
                          <a target="blank" href="https://apps.apple.com/mx/app/intermx/id1548367767?l=en">
                            <img style="width:10pc;height:3pc;margin:0.5pc;margin-left:0px" src="./assets/images/footer/AppleGris.png">
                          </a>
                          <p style="font-style:normal;font-size:0.8rem;color:#bdbebf;margin-bottom:15px;margin-top:30px">Siguenos</p>
                          <span class="white link" (click)="openWindow(16)"><img class="redes" src="./assets/images/redes/Logo_instagram.svg" /></span>
                          <span class="white link" (click)="openWindow(15)"><img class="redes" src="./assets/images/redes/Logo_facebook.svg" /></span>
                          <span class="white link" (click)="openWindow(21)"><img class="redes" src="./assets/images/redes/Logo_youtube.svg" /></span>
                          <span class="white link" (click)="openWindow(17)"><img class="redes" src="./assets/images/redes/Logo_linkedin.svg" /></span>
                          <span class="white link" (click)="openWindow(22)"><img class="redes" src="./assets/images/redes/Logo_TIKTOK.svg" /></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row-sio h-75x">
            <div class="cell-sio text-middle text-center">
                <p class="cuerpo white px-15x">Copyright2020 @INTERprotección | <span class="white link " style="color: #6e6f70;"  (click)="openWindow(14)">Aviso de privacidad</span></p>
            </div>
        </div>
    </div>
</div>
